import { style } from 'typestyle'
export const mr4 = style({ marginRight: '4px' })
